import React from 'react';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { ConfirmCloudPay } from '../component/confirm-cloudpay/ConfirmCloudPay';

export const AutoConfirmCloudPayPage = () => (
  <SignInPageLayout centerDesktop={<ConfirmCloudPay />} />
);
